import { getFiGrowthBook } from '../lib/growthbook';

/**
 * The in-site bag and checkout, which replace the shop handoff.
 *
 * Read before GrowthBook has loaded this resolves false, which keeps the shop CTA -- the safe
 * default, since the shop serves the same offer and the bag cannot render without one.
 *
 * Lives here rather than in `RegisterChipV2` because both that module and `SuccessStepV2` need it,
 * and `RegisterChipV2` already imports `SuccessStepV2`.
 */
export function useInSiteCheckoutEnabled() {
  return getFiGrowthBook().getFeatureValue('nano-in-site-checkout', false);
}

/**
 * The merged success screen, which folds the upgrade step into the confirmation.
 *
 * Read before GrowthBook has loaded this resolves false, which is the control path -- the
 * upgrade step still renders and its CTA still lands on success, so both orderings converge
 * on the same screen and there is no broken intermediate state.
 */
export function useMergedSuccessEnabled() {
  return getFiGrowthBook().getFeatureValue('nano-merged-success-screen', false);
}

/**
 * Asking an adopter whether their rescue sent them home with the Fi Mini on their pet, instead of
 * returning the collar to the rescue at registration.
 *
 * Read before GrowthBook has loaded this resolves false: registration then returns a rescue's collar
 * straight away, as it always has, and the question step redirects onward.
 */
export function useRescueCollarQuestionEnabled() {
  return getFiGrowthBook().getFeatureValue('nano-rescue-collar-question', false);
}

/**
 * Apple Pay and Google Pay as a row at the top of the in-site checkout, where the wallet sheet collects
 * the shipping address and phone, instead of as options in the payment list that still need the typed
 * address. Run as a 50/50 test.
 *
 * Read before GrowthBook has loaded this resolves false: the checkout as it was, wallets in the
 * payment list.
 */
export function useExpressWalletsEnabled() {
  return getFiGrowthBook().getFeatureValue('nano-checkout-express-wallets', false);
}
